import * as React from "react";
import { inject, observer } from "mobx-react";
import { Router as Router } from "react-router-dom";
import Master from "@templates/master";
import BasketCheckout from "@components/Order/BasketCheckout";


@inject("store")
@observer
export default class CheckoutTemplate extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {

        // query: Confirm="basketid"
        return (
            <Master {...this.props}>
                <BasketCheckout />
            </Master>
        );
    }
}

